// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"231":"8fcb6c7421ffcec99091","344":"299590dfd44d3e08f5fd","589":"de0163bbaa0e4bf6d34b","774":"72091dd747872dbed7d7"}[chunkId] + ".js";
};